import { IconControl, Loading } from "spark-core-dx/components";
import { useCardLayoutContext } from "../../../../contexts/CardLayoutContext";
import { useDashboardSourceDataContext } from "../../../../DashboardSourceDataProvider";
//import { BarChart, LineChart, PieChart, StackedBarChart, FlatNumber, TableCard } from "../../../charts";
import { LoadingScreen } from "../../../LoadingScreen";
import DynamicChart from "../../../charts/DynamicChart";

export const CardTileBody = ({ card, visual }) => {

    const {
        isVisualLoading,
        visualErrors,
        getCacheKey,
        retryPullDataset
    } = useDashboardSourceDataContext()

    const {
        isDragging
    } = useCardLayoutContext();

    const isLoading = visual ? isVisualLoading(visual) : false;

    const cacheKey = visual ? getCacheKey(visual) : "";
    const error = cacheKey ? (visualErrors[cacheKey] ?? []) : [];

    const handleRetry = () => {
        if (visual) retryPullDataset(visual)
    }

    const vid = String(visual?.VisualId ?? visual?.visualId ?? "");

    return (
        <div className={`card-tile-body`}>
            <LoadingScreen isLoading={isLoading || (vid && (isDragging === vid))} fadeIn={true}>
                <Loading type={"spinner-2"} />
            </LoadingScreen>

            {error?.length > 0 ?
                <div className="chart-error">
                    {error?.includes(404) ?
                        <>
                            <span>Dataset unavailable.</span>
                            <span>Please contact an administrator to resolve this issue.</span>
                        </>
                        :
                        <>
                            <span>
                                An error occurred, please try again.
                            </span>
                            <IconControl onClick={handleRetry} onMouseDown={(e) => e.stopPropagation()} iconKey={"retry"} />
                        </>
                    }
                </div>
                : (vid && !(isDragging === vid)) ?
                    <>
                        <DynamicChart visual={visual} demoType="bar"/>
                    </>
                    : null}
        </div>
    )
}
/*
           {visualType === 'bar' && visual && <BarChart visual={visual} />}
                        {visualType === 'stackedbar' && visual && <StackedBarChart visual={visual} />}
                        {visualType === 'line' && visual && <LineChart visual={visual} />}
                        {visualType === 'pie' && visual && <PieChart visual={visual} />}
                        {visualType === 'flatnumber' && visual && <FlatNumber visual={visual} />}
                        {visualType === 'table' && visual && <TableCard height={card.h} visual={visual} />}
*/